import { get } from 'lodash';

export const selectAuthenticatedUser = state => get(state, ['auth', 'user']);

export const selectpropertyManagerDetails = state => get(state, ['auth', 'propertyManagerDetails'])